import { RoleEnum } from '@zaoblako/shared/modules/security/enums/role.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { RoleEnumI18n } from '@zaoblako/shared/modules/security/i18n/role.enum.i18n';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';

import * as yup from 'yup';

const ROLE_ENUM_ERROR_MESSAGE_AVAILABLE: string = Object
  .keys(RoleEnumI18n[I18nLocalesEnum.RU_RU])
  .map(key => `"${key}" (${RoleEnumI18n[I18nLocalesEnum.RU_RU][key]})`)
  .join(', ');

/** Role create/update request body */
export interface RoleFormInterface {
  /** Display name */
  name: string;
  /** Role type */
  type: RoleEnum;
}

/** Role create/update request body DTO schema */
export const RoleFormDto = SerdeDtoClass.create<RoleFormInterface>('security/role-form.dto', {
  name: {
    label: 'Название',
    checkers: [SecurityBackendValidatorsEnum.ROLE_NAME_UNIQUE],
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  type: {
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(
        Object.values(RoleEnum),
        `Недопустимый тип роли. Тип роли может принимать только следующие значения: ${ROLE_ENUM_ERROR_MESSAGE_AVAILABLE}.`
      )
  },
})
